














import { Component, Prop, Vue } from 'vue-property-decorator';
import { MentoringListItem } from './components';
import { PopupData, Meetings, IMentoringList } from './types';

@Component({
  components: {
    MentoringListItem,
  },
})
export default class MentoringList extends Vue implements IMentoringList {
  @Prop({ type: Array, default: () => [] })
  readonly list!: Meetings;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/programcard/components/main/components/list/MentoringList.vue